var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21999 14.2267C7.49332 14.2267 6.76665 13.9533 6.21332 13.4C5.10665 12.2933 5.10665 10.5 6.21332 9.39332L7.86665 7.74666C8.05999 7.55332 8.37999 7.55332 8.57332 7.74666C8.76665 7.93999 8.76665 8.25999 8.57332 8.45332L6.91999 10.1C6.20665 10.8133 6.20665 11.98 6.91999 12.6933C7.63332 13.4067 8.79999 13.4067 9.51332 12.6933L12.1067 10.1C12.8933 9.31332 13.3267 8.26666 13.3267 7.15332C13.3267 6.03999 12.8933 4.99332 12.1067 4.20666C10.48 2.57999 7.83999 2.57999 6.21332 4.20666L3.38665 7.03332C2.72665 7.69332 2.35999 8.57332 2.35999 9.50666C2.35999 10.44 2.72665 11.32 3.38665 11.98C3.57999 12.1733 3.57999 12.4933 3.38665 12.6867C3.19332 12.88 2.87332 12.88 2.67999 12.6867C1.83332 11.8333 1.35999 10.7067 1.35999 9.50666C1.35999 8.30666 1.82665 7.17332 2.67999 6.32666L5.50665 3.49999C7.51999 1.48666 10.8 1.48666 12.8133 3.49999C13.7867 4.47332 14.3267 5.77332 14.3267 7.15332C14.3267 8.53332 13.7867 9.83332 12.8133 10.8067L10.22 13.4C9.66665 13.9533 8.94665 14.2267 8.21999 14.2267Z",
    fill: "black",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.50776e247a91d4ed04f063bb0f5a1d5b.svg";
export { ForwardRef as ReactComponent };